import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Button, Group, Stack } from '@mantine/core';

/** Owned by G20 (plan.md S0). Screen-group layout: a sub-nav row + `<Outlet/>`
 * for the six purchasing-intake screens (mirrors `_authenticated.tsx`'s own
 * layout+Outlet pattern one level down). Includes supplier contracts.
 * "Receive without weighbridge" was folded into "Receive a load" as an
 * optional step (Stuart ruling 2026-08-25, BUILD_SPEC.md §8.1) — six tabs,
 * not seven. */
export const Route = createFileRoute('/_authenticated/purchasing-intake')({
  component: PurchasingIntakeLayout,
});

// Exported so nav.test.ts can assert NAV_SECTIONS' "Purchasing & Intake" children
// mirror this verbatim (label + to + order) rather than drifting silently.
export const TABS: ReadonlyArray<{ to: string; label: string; exact: boolean }> = [
  { to: '/purchasing-intake', label: 'Receive a load', exact: true },
  { to: '/purchasing-intake/purchase-orders', label: 'Purchase orders', exact: false },
  { to: '/purchasing-intake/suppliers', label: 'Suppliers', exact: false },
  { to: '/purchasing-intake/contracts', label: 'Contracts', exact: false },
  { to: '/purchasing-intake/reorder', label: 'Reorder', exact: false },
  { to: '/purchasing-intake/receipts', label: 'Receipts', exact: false },
];

function PurchasingIntakeLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <Stack gap="lg">
      <Group gap="xs" wrap="wrap">
        {TABS.map((tab) => {
          const active = tab.exact ? pathname === tab.to : pathname.startsWith(tab.to);
          return (
            <Button key={tab.to} component={Link} to={tab.to} variant={active ? 'filled' : 'light'} size="sm">
              {tab.label}
            </Button>
          );
        })}
      </Group>
      <Outlet />
    </Stack>
  );
}
